<div class="multi-action" [formGroup]="settingsForm">
  <div class="multi-action_container" formGroupName="Prmodel">
    <div class="input-container">
      <div class="input-container_label">Repricing Model:</div>
      <select
        class="input-container_input input-container_input--thin"
        formControlName="name"
      >
        <option *ngFor="let option of options" [value]="option.modelId">
          {{ option.name }}
        </option>
      </select>
    </div>
    <div class="multi-action_switch">
      <app-input-switcher
        [options]="[
          { display: 'On', value: true },
          { display: 'Off', value: false }
        ]"
        formControlName="isActive"
      ></app-input-switcher>
    </div>
  </div>

  <div class="multi-action_container" formGroupName="Map">
    <div class="input-container">
      <div class="input-container_label">MAP Price:</div>
      <div class="input-container_wrapper">
        <input
          type="number"
          class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
          formControlName="price"
          appDecimalNumber="2"
          min="0"
        />
        <span class="input-container_icon input-container_icon--small">
          <i class="fa fa-dollar-sign"></i>
        </span>
      </div>
    </div>
    <div class="multi-action_switch">
      <app-input-switcher
        [options]="[
          { display: 'On', value: true },
          { display: 'Off', value: false }
        ]"
        formControlName="isActive"
      ></app-input-switcher>
    </div>
  </div>

  <div class="multi-action_container" formGroupName="Markup">
    <div class="input-container">
      <div class="input-container_label">Markup Percent:</div>
      <div class="input-container_wrapper">
        <input
          type="number"
          class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
          formControlName="price"
          min="0"
        />
        <span class="input-container_icon input-container_icon--small">
          <i class="fa fa-percent"></i>
        </span>
      </div>
    </div>
  </div>

  <div class="multi-action_container" formGroupName="MinMarkup">
    <div class="input-container">
      <div class="input-container_label">Min Markup:</div>
      <div class="input-container_wrapper">
        <input
          type="number"
          class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
          formControlName="price"
          appDecimalNumber="2"
          min="0"
        />
        <span class="input-container_icon input-container_icon--small">
          <i class="fa fa-dollar-sign"></i>
        </span>
      </div>
    </div>
  </div>

  <ng-template ngIf="skus.length === 1">
    <div class="multi-action_container" formGroupName="Cost">
      <div class="input-container">
        <div class="input-container_label">Cost:</div>
        <div class="input-container_wrapper">
          <input
            type="number"
            class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
            formControlName="price"
            appDecimalNumber="2"
            min="0"
          />
          <span class="input-container_icon input-container_icon--small">
            <i class="fa fa-dollar-sign"></i>
          </span>
        </div>
      </div>
    </div>

    <div class="multi-action_container" formGroupName="Minpr">
      <div class="input-container">
        <div class="input-container_label">Min Price:</div>
        <div class="input-container_wrapper">
          <input
            type="number"
            class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
            formControlName="price"
            appDecimalNumber="2"
            min="0"
          />
          <span class="input-container_icon input-container_icon--small">
            <i class="fa fa-dollar-sign"></i>
          </span>
        </div>
      </div>
      <div class="multi-action_switch">
        <app-input-switcher
          [options]="[
            { display: 'Auto', value: true },
            { display: 'Manual', value: false }
          ]"
          formControlName="isAuto"
        ></app-input-switcher>
      </div>
    </div>

    <div class="multi-action_container" formGroupName="Maxpr">
      <div class="input-container">
        <div class="input-container_label">Max Price:</div>
        <div class="input-container_wrapper">
          <input
            type="number"
            class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
            formControlName="price"
            appDecimalNumber="2"
            min="0"
          />
          <span class="input-container_icon input-container_icon--small">
            <i class="fa fa-dollar-sign"></i>
          </span>
        </div>
      </div>
      <div class="multi-action_switch">
        <app-input-switcher
          [options]="[
            { display: 'Auto', value: true },
            { display: 'Manual', value: false }
          ]"
          formControlName="isAuto"
        ></app-input-switcher>
      </div>
    </div>

    <div class="multi-action_container" formGroupName="DefaultPrice">
      <div class="input-container">
        <div class="input-container_label">Default Price:</div>
        <div class="input-container_wrapper">
          <input
            type="number"
            class="input-container_input input-container_input--thin input-container_input--number input-container_input--mini"
            formControlName="price"
            appDecimalNumber="2"
            min="0"
          />
          <span class="input-container_icon input-container_icon--small">
            <i class="fa fa-dollar-sign"></i>
          </span>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="multi-action_confirm">
    <!--    <app-button-->
    <!--      [buttonStyle]="'underline'"-->
    <!--      [buttonSize]="'action'"-->
    <!--      (click)="view()"-->
    <!--      >Cancel</app-button-->
    <!--    >-->
    <app-button
      [buttonStyle]="'underline'"
      [buttonSize]="'action'"
      (click)="resetForm()"
      >Reset</app-button
    >
    <app-button
      [buttonSize]="'action'"
      [spin]="isLoading"
      [isDisabled]="settingsForm.invalid"
      (click)="submit()"
      >Save</app-button
    >
  </div>
</div>
